export const Routes = {
    HOME: '/',
    LOGIN: '/login',
    REFRESH_LOGIN: '/refresh-login',
    UNAUTHORIZED: '/unauthorized',
    ADMIN: '/admin',
    UNSUBSCRIBE: '/unsubscribe'
};
